module.exports = __webpack_public_path__ + "media/images/auth-bg@1-5e90ffba.png";